var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-empty"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/nodata.png"),"alt":""}}),_c('h4',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }